import i18n from '@/i18n';

const configModalRule = {
    id: '',
    title: '新規登録',
    titleBtnSave: '登録',
    model: false,
    scrollable: true,
    hideFooter: false,
    size: '2xl',
    validate: true
};

const shortCode = [
    '《キャンペーン名》',
    '《クライアント名》',
    '《年末年始休み》',
    '《キャンペーン開始》',
    '《キャンペーン終了》',
    '《対象商品名》',
    '《事務局開始》',
    '《事務局終了》',
    '《主催者(流通)名》',
    '《協賛メーカー》',
    '《EJOICAセレクトギフト》',
    '《クオカードペイ》',
    '《公式Twitterアカウント名》',
    '《公式Instagramアカウント名》',
    '《LINE公式アカウント名》',
    '《抽選(当選人数)》',
    '《賞品発送時期》',
    '《CP指定ハッシュタグ》',
    '《応募種別》',
    '《Amazon当選者数》',
    '《EJOICA当選者数》',
    '《QUO当選者数》',
    '《対象商品金額》',
    '《流通合計金額》',
    '《対象商品合計金額》',
    '《対象商品個数》',
    '《Amazonギフト》',
    '《公式アカウント・ID》'
];

const IF_CONDITION = ['AND', 'OR', 'NOT', 'AND NOT'];

function configForm() {
    return {
        configFieldOption: {
            trackBy: 'id',
            label: 'value',
            error: false,
            isRemove: false,
            errorField: '配置',
            valueSync: null,
            isRequired: false,
            typesValidate: ['requiredSelect']
        },
        configFieldClassic: {
            trackBy: 'id',
            label: 'value',
            error: false,
            isRemove: false,
            errorField: '区分',
            valueSync: null,
            isRequired: false,
            typesValidate: ['requiredSelect']
        },
        configFieldDetail: {
            error: false,
            valueSync: null,
            isRequired: false,
            errorField: '条文・細則',
            typesValidate: ['required']
        },
        configFieldLogicFormula: {
            error: false,
            valueSync: null,
            isRequired: false,
            errorField: i18n.t('screenRule.settingFomulator'),
            typesValidate: []
        }
    };
}

function initDataForm() {
    return {
        detail: '',
        logic_formula: '',
        option: null,
        classification: null,
        is_default: false
    };
}

export { configModalRule, shortCode, IF_CONDITION, configForm, initDataForm };
